import React, { useEffect, useState } from "react";
import PrivateApi from '../../services/PrivateApiService';
import SplashPage from "../SplashPage";
import { Col, Container, Row } from "react-bootstrap";
import InvoiceClassCard from "../../components/download/InvoiceClassCard";
import DownloadList from "../../components/download/DownloadList";
import { useQuery } from "react-query";
import { useAuthState } from "../../context/AuthContext";
import EnergoTooltip from "../../components/shared/Tooltip";


/**
 * DownloadPage
 * 
 * here can customer download his latest invoices 
 * 
 * @returns none
 */
const DownloadPage = () => {

    const API = new PrivateApi(); // API calls
    const {tooltips, tooltipsTrigger, user} = useAuthState();

    const [dataLoading, setDataLoading] = useState(true); // state for showing/hidding SplashPage
    const [selectedInvoices, setSelectedInvoices] = useState([]); // array state for selected invoice
    const [types, setTypes] = useState([ // object state for types of invoices
        { id: 1, name: "Poolrechnungen", count: 0, last: "" },
        { id: 2, name: "Energielieferant", count: 0, last: "" },
        { id: 3, name: "Vorschreibungen", count: 0, last: "" },

    ]);

    const [invoices, setInvoices] = useState([]); // array state of all invoices 
    const [poolrechnungen, setPoolrechnungen] = useState([]); // array state of poolrechnungen
    const [abrechnungen, setAbrechnungen] = useState([]); // array state of abrechnungen
    const [vorschreibungen, setVorschreibungen] = useState([]); // array state of vorschreibungen

    const [selectedType, setSelectedType] = useState([]); // array state of selected types of invoices


    const { data, error, isLoading } = useQuery("GET_ALL_INVOICES", API.get_InvoicesUser, {
        staleTime: Infinity,
    })

    // initial Effect to gether all needed data
    useEffect(() => {
        if (!isLoading && data !== undefined) {
            let res = data.data;
            let sel_type = [];
            if (res.poolrechnungen?.length > 0) sel_type.push(1);
            if (res.abrechnungen?.length > 0) sel_type.push(2);
            if (res.vorschreibungen?.length > 0) sel_type.push(3);
            setSelectedType(sel_type);
            setInvoices(res.poolrechnungen.concat(res.abrechnungen).concat(res.vorschreibungen));
            setPoolrechnungen(res.poolrechnungen);
            types[0].count = res.poolrechnungen.length > 0 ? Number(res.poolrechnungen.length) : 0;
            if (res.poolrechnungen && res.poolrechnungen.length > 0) types[0].last = new Date(res.poolrechnungen[0].x_rechnungsdatum).toLocaleDateString('DE-de');
            setAbrechnungen(res.abrechnungen);
            types[1].count = res.abrechnungen.length > 0 ? Number(res.abrechnungen.length) : 0;
            res.abrechnungen.filter(a => a.x_datum_download === 'False' && a.x_file_stornorechnung_name !== 'False' ? types[1].count += 1 : null)
            res.abrechnungen.filter(a => a.x_datum_download === 'False' && a.x_file_mahnung_name !== 'False' ? types[1].count += 1 : null)
            if (res.abrechnungen && res.abrechnungen.length > 0) types[1].last = new Date(res.abrechnungen[res.abrechnungen.length - 1].x_eingangsdatum).toLocaleDateString('DE-de');
            setVorschreibungen(res.vorschreibungen);
            types[2].count = res.vorschreibungen.length > 0 ? Number(res.vorschreibungen.length) : 0;
            res.vorschreibungen.filter(v => v.x_datum_download === 'False' && v.x_file_mahnung_name !== 'False' ? types[2].count += 1 : null)
            if (res.vorschreibungen && res.vorschreibungen.length > 0) types[2].last = new Date(res.vorschreibungen[res.vorschreibungen.length - 1].create_date).toLocaleDateString('DE-de');
            setSelectedInvoices(res.poolrechnungen.concat(res.abrechnungen).concat(res.vorschreibungen));
        }
    }, [isLoading, data]);


    // Effect triggers when selectedType array changes then filters invoices
    useEffect(() => {
        setSelectedInvoices(invoices)
        if (selectedType.length > 0) {
            var filtered_glob = [];
            var filtered1 = [];
            var filtered2 = [];
            var filtered3 = [];
            for (var i = 0; i < selectedType.length; i++) {
                if (selectedType[i] === 1) {
                    filtered1 = invoices.filter(i => i.x_rechnungsdatum !== undefined);
                }
                if (selectedType[i] === 2) {
                    filtered2 = invoices.filter(i => i.x_eingangsdatum !== undefined);
                }
                if (selectedType[i] === 3) {
                    filtered3 = invoices.filter(i => i.x_datum_tzb_einzug !== undefined);
                }
            }
            var all = [...filtered1, ...filtered2, ...filtered3];
            filtered_glob = all;
            setSelectedInvoices(filtered_glob);
        }
        if (selectedType.length === 0) setSelectedInvoices([]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedType])


    if (isLoading) return <SplashPage />;
    if (error) return <SplashPage error={error} />;

    // GUI
    return (
        <Container>
            <Row className="text-start mb-5">
                <Col>
                    <div style={{display: "flex"}}>
                        <h3 style={{marginRight: 10}}>{user.x_is_house_management? "Download": "Neue Dokumente"}</h3>
                        {tooltipsTrigger?
                            tooltips.find(t => t.code === 5001) !== undefined?
                                <EnergoTooltip text={tooltips.find(t => t.code === 5001).help_text} position="right" /> : null
                        :null}
                    </div>
                    <p className="text-muted">Hier können Sie Ihre neuesten Dokumente downloaden</p>
                </Col>
            </Row>
            <Row className="mt-5 text-start">
                <h5 className="text-energo">Schnellzugriff</h5>
                {types.map(t => (
                    <InvoiceClassCard select={setSelectedType} selected={selectedType} type={t} key={t.id} />
                ))}
            </Row>
            <Row className="mt-5 text-start">
                <Col xs="12">
                    <h5 className="text-energo">Dokumente</h5>
                    <DownloadList invoices={selectedInvoices} />
                </Col>
            </Row>
        </Container>
    )
}

export default DownloadPage;